import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=2b07fe12"
import script from "../../script/customer-service/client.js?vue&type=script&lang=js&external"
export * from "../../script/customer-service/client.js?vue&type=script&lang=js&external"
import style0 from "../../less/customer-service/client.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports